import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LanguageService } from './language.service';
import { ApplicationLanguages } from '../components/language/language';

@Injectable({
  providedIn: 'root'
})
export class TranslationService {
  private translations: any;
  constructor(private http: HttpClient, private langservice: LanguageService) { }

  getTranslation(): Observable<any> {
    let language = this.langservice.getCurretnLang();
    let fileName = 'en';

    switch (language) {
      case ApplicationLanguages.FRENCH:
        fileName = 'fr'
        break;
      default:
        fileName = 'en'
        break;
    }
    return this.http.get(`assets/i18n/${fileName}.json`);
  }


}
